/**
 * First-time-player onboarding flag, persisted locally. Drives the one-time
 * "new here?" nudge on the home screen; cleared once the player has opened the
 * rules or dismissed the prompt.
 */
import { createSignal } from "solid-js";

const KEY = "cd-onboarded";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return true; // no storage (private mode): don't nag
  }
}

const [onboarded, setOnboarded] = createSignal(read());
export { onboarded };

export function markOnboarded(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* ignore */
  }
  setOnboarded(true);
}
